import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const MinimizeIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
    />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default MinimizeIcon;
